module.exports = __webpack_public_path__ + "img/cat-inspection.b49aec6d.png";